import { Component, OnInit, Input } from '@angular/core';
import {TranslateService} from '@ngx-translate/core'
import { Platform, LoadingController, ModalController, NavController, NavParams } from '@ionic/angular';
import {GeneralServices} from '../../services/generalServices';
import { Router, ActivatedRoute } from '@angular/router';
import { FormatoGenericoService } from './formato-generico.service';
import { RxStompService} from '@stomp/ng2-stompjs';
@Component({
  selector: 'app-formato-generico',
  templateUrl: './formato-generico.page.html',
  styleUrls: ['./formato-generico.page.scss'],
  providers:[TranslateService, GeneralServices, FormatoGenericoService]
})
export class FormatoGenericoPage implements OnInit {

  @Input() paramsGenericFormat;
  @Input() estudio;
  public errorMessage;
  public contenido;
  public loader;
  public signature;
  public capturarFirmaOn = true;
  public firmaGuardada = '';

  constructor(private platform: Platform, 
    private translate: TranslateService, 
    private _generalServices:GeneralServices,
    private loadingCtrl: LoadingController,
    private _formatoGenericoService:FormatoGenericoService,
    private route: ActivatedRoute,
    private router:Router,
    public navCtrl: NavController, public navParams: NavParams,
    public modalController: ModalController,
    private rxStompService: RxStompService) {
      
      /*this.route
      .queryParams
      .subscribe(params => {
        this.paramsGenericFormat = JSON.parse(params['paramsGenericFormat']);
        
        }
      )*/

    this._generalServices.setLanguage(this.translate);    
   }

  ngOnInit() {
    console.log(this.paramsGenericFormat);
console.log('.: '+this.estudio);


    this.paramsGenericFormat = JSON.parse(this.paramsGenericFormat);
    console.log(this.paramsGenericFormat)

    this.loadFormatoGenerico();
  }

  loadFormatoGenerico(){
    let IdFirma = this.paramsGenericFormat.IdFirma;
    if(this.paramsGenericFormat.IdFirma == undefined || this.paramsGenericFormat.IdFirma == ''){
      IdFirma = '';
    }
    this._formatoGenericoService.getFormatoGenerico(this.paramsGenericFormat.IdFormatoGenerico,this.paramsGenericFormat.Estudio,IdFirma).subscribe(
      result => {
          
          result = result["Datos"];     
             
        if(result!=''){
            this.contenido = result[0].Contenido;
            this.firmaGuardada = $.trim(result[0].Firma);
        }
      },
      error =>{
        this.errorMessage = <any>error;
        if(this.errorMessage !== null){
          console.log(this.errorMessage);
        }
      }
      );
  }

  /*capturarFirma(){
    this.router.navigate(['/capturar-firma']);    
    //this.router.navigate(['/configuracion']);    
  }*/

  capturarFirma(){
    let _thisClass=this;
  
      /*this.loader = this.loadingCtrl.create({
                      content: _thisClass.translate.instant('LOAD_MSG_INICIAR_SESION'),
                    });
      this.loader.present();*/
  
      
      this._formatoGenericoService.GuardarFirma(this.paramsGenericFormat.IdFormatoGenerico, 'historia', this.paramsGenericFormat.Estudio, this.signature).subscribe(
      result => {

       
        this.rxStompService.publish({destination: '/topic/Zeus.Hefesto.UserTopic.receiveGenericFormat.'+this.paramsGenericFormat.IdUsuario, body: "success"});

        this._generalServices.toastNotify("Se ha enviado la firma correctamente.","success");
        //this._parent.modalController.dismiss();
        this.modalController.dismiss();
        //this.loader.dismiss();      
                
      },
      error =>{
        this._generalServices.errorManager(error,_thisClass.loader,false);
      }
      );

    /*
    let _class = this;
    const modal = await this.modalController.create({
      component: CapturarFirmaPage,
      componentProps: {
        _parent:_class,
        paramsGenericFormat:this.paramsGenericFormat
      }
    });
    return await modal.present();*/
    
   // this.router.navigate(['/formato-generico'],{queryParams:{paramsGenericFormat:this.paramsGenericFormat}});    
  }

  drawStart(){
    if(this.signature != '' && this.signature != undefined){
      this.capturarFirmaOn = false;
    }
  }

  closeModal(){
    this.modalController.dismiss();
  }
}
